import { render } from "./AlzataDropdown.vue?vue&type=template&id=ea89f874"
import script from "./AlzataDropdown.vue?vue&type=script&lang=js"
export * from "./AlzataDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__